export var IPublicEnumContextMenuType = /*#__PURE__*/function (IPublicEnumContextMenuType) {
  IPublicEnumContextMenuType["SEPARATOR"] = "separator";
  IPublicEnumContextMenuType["MENU_ITEM"] = "menuItem";
  IPublicEnumContextMenuType["NODE_TREE"] = "nodeTree";
  return IPublicEnumContextMenuType;
}({});